import React from 'react'
import { CoefficientsList } from './list/page'

export const Bonus150SettingsPage = () => {
  return <CoefficientsList />
}
